import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { Subscription } from "rxjs";
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-packages-carousel',
  templateUrl: './packages-carousel.component.html',
  styleUrls: ['./packages-carousel.component.sass']
})
export class PackagesCarouselComponent implements OnInit {
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan: string;
  public myInterval = 30000;
  public info = [];
  public expand = [];
  public token: string = sessionStorage.getItem("token");
  public acodetail_acoinf_credit;
  public tipo_aco;
  public subtipo_cuenta;
  loadObserver: Subscription;
  public typeActual = '';
  public planActual = '';
  public rectaActual;
  public planToChange = '';
  public nextSoc = '';
  public subscriberNumber = '';
  public descriptions = '';
  public pricePlan = 0.00;
  public amount;
  public ivuState;
  public tax;
  public totalPagar;

  @Output() updatescreenview = new EventEmitter<any>();
  @Input() index;
  @Input() long_off;
  @Input() offer2;
  @Input() offers;
  @Input() orignomo;
  @Input() total_rate;
  @Input() prod_type;
  @Input() sub_num;
  @Input() info_soc;
  @Input() currentPlan;
  @Input() actualPrice;
  @Input() productType;
  @Input() currentplanId;
  @Input() subscriber;
  @Input() textoMovil;
  @Input() nextDate;
  @Input() commitmentOriginalMonths;
  @Input() numberOrder;
  @Input() balance;
  @Input() type;
  @Output() updateCurrentPlan = new EventEmitter;
  @Output() updateActualPrice = new EventEmitter;
  @Output() updatePlanToChange = new EventEmitter;
  @Output() updateDescriptions = new EventEmitter;
  @Output() updatePricePlan = new EventEmitter;
  @Output() updateNextDate = new EventEmitter;
  @Output() checkTextMobile = new EventEmitter;
  @Output() viewNextDate = new EventEmitter;
  @Output() checkContract = new EventEmitter;
  @Output() validateType = new EventEmitter;
  @Output() viewNextSoc = new EventEmitter;
  @Output() viewActualSoc = new EventEmitter;
  @Output() viewSubscriberNumber = new EventEmitter;
  @Output() updateSwOrder = new EventEmitter;
  @Output() viewNumberOrder = new EventEmitter;
  @Output() updateId = new EventEmitter;
  public auxList = [];

  constructor(private global: GlobalService, private router: Router, private services: Service,private loadingScreenService: LoadingScreenService) { }

  ngOnInit() {
    console.log(this.offers)
    if (this.global.sessionReview() == true) {
      this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    }

    setTimeout(()=> {
      let auxList: any [] = this.offers.offers[this.index].offers[0].offersData;
      auxList.forEach((element: any) => {
        element.offers.forEach(value => {
          this.auxList.push(value);
        });
      });
    }, 3000);
  }
  changePlanBtn(id,commitmentOriginalMonths, planToChange, description, pricePlan, idPlan, accountSubType, accountType) {
    if(this.global.validateSession()===true){
      if(this.type=='prepaid'){
        if(this.balance>=pricePlan){
          this.checkContract.emit(this.commitmentOriginalMonths);
          this.updateId.emit(id);
          this.updateCurrentPlan.emit(this.currentPlan);
          this.updateActualPrice.emit(this.actualPrice);
          this.updatePlanToChange.emit(planToChange);
          this.updateDescriptions.emit(description);
          this.updatePricePlan.emit(pricePlan);
          this.checkTextMobile.emit(this.textoMovil);
          this.viewNextDate.emit(this.nextDate);
          this.validateType.emit(this.productType);
          this.viewNextSoc.emit(idPlan);
          this.viewActualSoc.emit(this.currentplanId);
          this.viewSubscriberNumber.emit(this.subscriber);
          this.updatescreenview.emit(2);
          this.viewNumberOrder.emit(this.numberOrder);
          if (this.productType == 'G') {
            this.textoMovil = false;
          }
          else {
            this.checkTextMobile.emit(true);
          }
        }
        else{
          // this.global.notif("El plan seleccionado tiene un costo mayor a su balance disponible, por favor realice el pago de $00.00 para procesar su solicitud de cambio de plan.");
          // this.router.navigate(['recharge']);
          this.checkContract.emit(this.commitmentOriginalMonths);
          this.updateId.emit(id);
          this.updateCurrentPlan.emit(this.currentPlan);
          this.updateActualPrice.emit(this.actualPrice);
          this.updatePlanToChange.emit(planToChange);
          this.updateDescriptions.emit(description);
          this.updatePricePlan.emit(pricePlan);
          this.checkTextMobile.emit(this.textoMovil);
          this.viewNextDate.emit(this.nextDate);
          this.validateType.emit(this.productType);
          this.viewNextSoc.emit(idPlan);
          this.viewActualSoc.emit(this.currentplanId);
          this.viewSubscriberNumber.emit(this.subscriber);
          this.updatescreenview.emit(2);
          this.viewNumberOrder.emit(this.numberOrder);
        }
      }
      else{
        this.checkContract.emit(this.commitmentOriginalMonths);
        this.updateId.emit(id);
        this.updateCurrentPlan.emit(this.currentPlan);
        this.updateActualPrice.emit(this.actualPrice);
        this.updatePlanToChange.emit(planToChange);
        this.updateDescriptions.emit(description);
        this.updatePricePlan.emit(pricePlan);
        this.checkTextMobile.emit(this.textoMovil);
        this.viewNextDate.emit(this.nextDate);
        this.validateType.emit(this.productType);
        this.viewNextSoc.emit(idPlan);
        this.viewActualSoc.emit(this.currentplanId);
        this.viewSubscriberNumber.emit(this.subscriber);
        this.updatescreenview.emit(2);
        this.viewNumberOrder.emit(this.numberOrder);
        if (this.productType == 'G') {
          this.textoMovil = false;
        }
        else {
          this.checkTextMobile.emit(true);
        }
      }

    }
  }
}
